export function range(start: number = 0, end: number, step: number = 1) {
  return {
    *[Symbol.iterator]() {
      let newStart = start,
        newEnd = end
      if (end < start) {
        newStart = end
        newEnd = start
      }
      for (let i = newStart; i < newEnd; i += step) {
        yield i
      }
    },
  }
}
